import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormulaireServiceService } from '../../../services/formulaire-service.service';
import { LogService } from '../../../../../modules/shared/services/log.service';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { JsonContentEnum } from 'src/app/models/enums/json-content.enum';
import { TypeAnn } from '../../../common/models/type.ann';
import { AnnonceurService } from '../../../common/services/annonceur/annonceur.service';
import { BehaviorSubject } from 'rxjs';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { ObjectToJsonStepperCreatorService } from '../../../../shared/services/object-to-json-stepper-creator.service';
import { MapaIn } from '../../../../shared/models/component-messages/mapaIN/mapa_in';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';
import { SpinnerVisibilityService } from 'ng-http-loader';

@Component({
  selector: 'app-initialformmapa',
  templateUrl: './formmapa.component.html'
})
export class FormmapaInitialComponent implements OnInit {

  private LOG: LogService = new LogService(FormmapaInitialComponent);

  @Input() indexPage: any;
  @Input() disabled = true;
  @Input() linkForRouter: string;
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() form: FormGroup;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  @Input() formName: string;
  @Input() diffBoamp = false;
  @Input() diffJoue = false;
  public createForm = false;

  public isFormValid = true;
  public ann = new TypeAnn();
  public mapaIn = new MapaIn()
  public steps = [6,7,8,9,10,11,12,13,14,15,16,17,18,19]
  public pages: number[];

  constructor(private formulaireServiceService: FormulaireServiceService,
    private annonceurService: AnnonceurService,
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private avisDataTransferService:AvisDataTransferService,
    private stepperBuilderService: StepperBuilderService,
    private spinner: SpinnerVisibilityService
    ) {
  }

  public ngOnInit() {
    this.pages = Array.from({ length: 12 }, (_, index) => index + 1);
    this.initForm();
  }

  getUid(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_Initial';
  }

  getUidCommon(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_Annonce_index_1_SepSep_TypeAnn';
  }

  public validateForm() {
  }

  private initForm() {
    this.spinner.show();
    this.currentJson.subscribe(data => {
      if (data != null && typeof data != 'string'&& !this.createForm) {
        this.ann = data.jsonSaisieFormulaire.ann;
        if (data.jsonSaisieFormulaire.stepId && this.indexPage>0.4)
          this.indexPage = data.jsonSaisieFormulaire.stepId;
        this.createForm = true;
        this.canNavigateInStepperService.isBOAMPorJOUE = null;
        this.canNavigateInStepperService.isSHALorPS = null;
        this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
        this.avisDataTransferService.setFormData(data);
        this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
        this.avisDataTransferService.jsonCSV = data.jsonCSV;
        this.avisDataTransferService.contenuPdf = data.jsonPdf;
        this.spinner.hide();
      } else {
        this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.MAPA_IN, JsonContentEnum.EMPTY, data).subscribe(formData => {
          this.createForm = true;
          this.annonceurService.annonceurBhs.next(formData.jsonSaisieFormulaire.annonceur);
          this.ann = formData.jsonSaisieFormulaire.ann;
          const fluxAllerPA: any = formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
					this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
          this.avisDataTransferService.refConsultation=formData.refConsultation;
          this.avisDataTransferService.siret=formData.jsonSaisieFormulaire.ann.facturation.libelle.siret;
          this.avisDataTransferService.setFormData(formData);
          this.stepperBuilderService.initDefaultMapErrors('assets/data/errors/' + FormsEnum[FormsEnum.MAPA_IN] + '.json');
          this.stepperBuilderService.initDefaultFormAD('assets/data/formAD/' + FormsEnum[FormsEnum.MAPA_IN] + '.json');
          this.stepperBuilderService.initDefaultFormPDF('assets/data/formPDF/' + FormsEnum[FormsEnum.MAPA_IN] + '.json');
          this.spinner.hide();
        });
      }
    });
  }

  getIsCheckValid(indexPage) {
    return this.stepperBuilderService.getIsCheckValidate('_STEP_ID_' + indexPage);
  }

  getIntitule(indexPage) {
		return this.formulaireServiceService.hasTranslation(
		  this.mapaIn.step + indexPage
		)
		  ? this.mapaIn.step + indexPage
		  : this.mapaIn.commonStep + indexPage;
	  }

    getContents(indexPage) {
      switch (indexPage) {
        case this.steps[0]:
        return [];
        case this.steps[1]:
        return [];
        case this.steps[2]:
        return [];
        case this.steps[3]:
        return [];
        case this.steps[4]:
        return [];
        case this.steps[5]:
        return [];
        case this.steps[6]:
        return [];
        case this.steps[7]:
        return [];
        case this.steps[8]:
        return [];
        case this.steps[9]:
        return [];
        case this.steps[10]:
        return [];
        case this.steps[11]:
        return [];
        case this.steps[12]:
        return [];
        case this.steps[13]:
        return [];

      }
    }
}
